var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackCutMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30.5,
    r: 28.5,
    fill: "#222222",
    stroke: "#F05E5E",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8548 29.7473V20.0244C22.8548 18.0904 23.626 16.2356 24.9988 14.868C26.3717 13.5005 28.2336 12.7322 30.175 12.7322C32.1165 12.7322 33.9784 13.5005 35.3512 14.868C36.7241 16.2356 37.4953 18.0904 37.4953 20.0244V29.7473C37.4953 31.6814 36.7241 33.5362 35.3512 34.9037C33.9784 36.2713 32.1165 37.0396 30.175 37.0396C28.2336 37.0396 26.3717 36.2713 24.9988 34.9037C23.626 33.5362 22.8548 31.6814 22.8548 29.7473ZM42.3755 29.7473C42.3755 29.425 42.2469 29.1159 42.0181 28.8879C41.7893 28.66 41.479 28.532 41.1554 28.532C40.8319 28.532 40.5215 28.66 40.2927 28.8879C40.0639 29.1159 39.9354 29.425 39.9354 29.7473C39.9354 32.326 38.9071 34.7991 37.0766 36.6225C35.2462 38.4459 32.7636 39.4703 30.175 39.4703C27.5864 39.4703 25.1039 38.4459 23.2734 36.6225C21.443 34.7991 20.4147 32.326 20.4147 29.7473C20.4147 29.425 20.2862 29.1159 20.0574 28.8879C19.8286 28.66 19.5182 28.532 19.1947 28.532C18.8711 28.532 18.5608 28.66 18.332 28.8879C18.1031 29.1159 17.9746 29.425 17.9746 29.7473C17.9783 32.7592 19.103 35.6628 21.1312 37.8965C23.1594 40.1302 25.947 41.5353 28.955 41.8403V46.7625C28.955 47.0848 29.0835 47.394 29.3123 47.6219C29.5411 47.8498 29.8515 47.9779 30.175 47.9779C30.4986 47.9779 30.8089 47.8498 31.0377 47.6219C31.2665 47.394 31.3951 47.0848 31.3951 46.7625V41.8403C34.403 41.5353 37.1906 40.1302 39.2188 37.8965C41.247 35.6628 42.3718 32.7592 42.3755 29.7473Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00098 50.4348L49.9409 9.49497",
    stroke: "#F05E5E",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCutMicrophone);
export default __webpack_public_path__ + "static/media/blackCutMicrophone.afef2848c8e4a7aae442d0fdfa0adf10.svg";
export { ForwardRef as ReactComponent };